"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormsListComponent = void 0;
const lodash_1 = __importDefault(require("lodash"));
const jquery_1 = __importDefault(require("jquery"));
const react_1 = __importDefault(require("react"));
const querystring_1 = __importDefault(require("querystring"));
const uiComponents = __importStar(require("../UIComponents"));
const expressions_1 = require("@mwater/expressions");
const moment_1 = __importDefault(require("moment"));
// Searchable list of forms
class FormsListComponent extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            forms: null,
            search: ""
        };
    }
    componentDidMount() {
        // Get names and basic of forms
        const query = {};
        query.fields = JSON.stringify({
            "design.name": 1,
            "design.description": 1,
            roles: 1,
            created: 1,
            modified: 1,
            state: 1,
            isMaster: 1
        });
        query.selector = JSON.stringify({ design: { $exists: true }, state: { $ne: "deleted" } });
        query.client = this.props.client;
        // Get list of all form names
        jquery_1.default.getJSON(this.props.apiUrl + "forms?" + querystring_1.default.stringify(query), (forms) => {
            // Sort by modified.on desc but first by user
            forms = lodash_1.default.sortByOrder(forms, [
                (form) => ((this.props.extraTables || []).includes("responses:" + form._id) ? 1 : 0),
                (form) => (form.created.by === this.props.user ? 1 : 0),
                (form) => form.modified?.on
            ], ["desc", "desc", "desc"]);
            // TODO use name instead of design.name
            this.setState({
                forms: lodash_1.default.map(forms, (form) => {
                    let desc = expressions_1.ExprUtils.localizeString(form.design.description, null) || "";
                    if (desc) {
                        desc += " - ";
                    }
                    desc += T `Modified ${(0, moment_1.default)(form.modified?.on, moment_1.default.ISO_8601).format("ll")}`;
                    return {
                        id: form._id,
                        name: expressions_1.ExprUtils.localizeString(form.design.name, null),
                        desc
                    };
                })
            });
        }).fail((xhr) => {
            this.setState({ error: xhr.responseText });
        });
    }
    handleTableRemove = (table) => {
        if (confirm(T `Remove ${expressions_1.ExprUtils.localizeString(table.name, T.locale)}? Any widgets that depend on it will no longer work properly.`)) {
            return this.props.onExtraTableRemove(table.id);
        }
    };
    searchRef = (comp) => {
        // Focus
        if (comp) {
            return comp.focus();
        }
    };
    render() {
        let forms;
        if (this.state.error) {
            return react_1.default.createElement("div", { className: "alert alert-danger" }, this.state.error);
        }
        // Filter forms
        if (this.state.search) {
            const escapeRegExp = (s) => s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
            const searchStringRegExp = new RegExp(escapeRegExp(this.state.search), "i");
            forms = lodash_1.default.filter(this.state.forms, (form) => form.name.match(searchStringRegExp));
        }
        else {
            ;
            ({ forms } = this.state);
        }
        // Remove if already included
        forms = lodash_1.default.filter(forms || [], (f) => !(this.props.extraTables || []).includes(`responses:${f.id}`));
        let tables = lodash_1.default.filter(this.props.schema.getTables(), (table) => (table.id.match(/^responses:/) || table.id.match(/^master_responses:/)) && !table.deprecated);
        tables = lodash_1.default.sortBy(tables, (t) => t.name.en);
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("label", null, T `Included Surveys:`),
            tables.length > 0 ? (react_1.default.createElement(uiComponents.OptionListComponent, { items: lodash_1.default.map(tables, (table) => {
                    return {
                        name: expressions_1.ExprUtils.localizeString(table.name, T.locale),
                        desc: expressions_1.ExprUtils.localizeString(table.desc, T.locale),
                        onClick: this.props.onChange.bind(null, table.id),
                        onRemove: this.handleTableRemove.bind(null, table)
                    };
                }) })) : (react_1.default.createElement("div", null, T `None`)),
            react_1.default.createElement("br", null),
            react_1.default.createElement("label", null, T `All Surveys:`),
            !this.state.forms || this.state.forms.length === 0 ? (react_1.default.createElement("div", { className: "alert alert-info" },
                react_1.default.createElement("i", { className: "fa fa-spinner fa-spin" }),
                "\u00A0",
                T `Loading...`)) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("input", { type: "text", className: "form-control form-control-sm", placeholder: T `Search...`, key: "search", ref: this.searchRef, style: { maxWidth: "20em", marginBottom: 10 }, value: this.state.search, onChange: (ev) => this.setState({ search: ev.target.value }) }),
                react_1.default.createElement(uiComponents.OptionListComponent, { items: lodash_1.default.map(forms, (form) => ({
                        name: form.name,
                        desc: form.desc,
                        onClick: this.props.onChange.bind(null, "responses:" + form.id)
                    })) })))));
    }
}
exports.FormsListComponent = FormsListComponent;
